module.exports = __webpack_public_path__ + "static/media/global-map-m.65b92765.png";